import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollToTop } from '../hooks/useScrollToTop';

const NotFound: React.FC = () => {
  const { t } = useLanguage();

  // 페이지 마운트 시 상단으로 스크롤
  useScrollToTop();

  return (
    <div className="not-found-page">
      <div className="page-header">
        <div className="container">
          <h1>404</h1>
          <p className="page-description">
            {t('page_not_found_title')}
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="not-found-content">
            <h2>{t('page_not_found_message')}</h2>
            <p>{t('page_not_found_description')}</p>

            <div className="not-found-actions">
              <Link to="/" className="btn btn-primary btn-md">
                {t('go_home')}
              </Link>
              <Link to="/contact" className="btn btn-secondary btn-md">
                {t('contact')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
